import React from 'react';

import { DimensionValue, StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants';

import { StepICon } from './step-icon';

interface IStepProgressBarProps {
  totalSteps: number;
  completedSteps: number;
}

export const StepProgressBar = ({ totalSteps, completedSteps }: IStepProgressBarProps) => {
  if (totalSteps === 0) {
    return null;
  }

  const safeCompletedSteps = Math.min(completedSteps, totalSteps);
  const progress = totalSteps > 1 ? (safeCompletedSteps - 1) / (totalSteps - 1) : 0;

  return (
    <View style={styles.container}>
      <View style={styles.baseLine} />

      <View
        style={[
          styles.progressLine,
          {
            left: STEP_SIZE / 2,
            right: `${(1 - progress) * 100}%` as DimensionValue,
          },
        ]}
      />

      <View style={styles.stepsContainer}>
        {Array.from({ length: totalSteps }).map((_, index) => {
          const isCompleted = index < completedSteps;

          return (
            <View key={index}>
              {isCompleted ? (
                <StepICon size={'30'} fill={isCompleted ? primitive.$crunchyGreen : 'gray'} />
              ) : (
                <View key={index} style={[styles.step]} />
              )}
            </View>
          );
        })}
      </View>
    </View>
  );
};

const STEP_SIZE = 30;
const LINE_HEIGHT = 4;

export const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    height: STEP_SIZE,
  },

  baseLine: {
    position: 'absolute',
    left: STEP_SIZE / 2,
    right: STEP_SIZE / 2,
    height: LINE_HEIGHT,
    backgroundColor: 'lightgrey',
    borderRadius: LINE_HEIGHT / 2,
  },

  progressLine: {
    position: 'absolute',
    left: STEP_SIZE / 2,
    height: LINE_HEIGHT,
    backgroundColor: primitive.$crunchyGreen,
    borderRadius: LINE_HEIGHT / 2,
  },

  stepsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  step: {
    width: STEP_SIZE,
    height: STEP_SIZE,
    borderRadius: STEP_SIZE / 2,
    backgroundColor: 'lightgrey',
  },
});
